import React from "react";

import { useFormatDate } from "./useFormatDate";
import { DateValue } from "../../utils/dateUtils";

interface Props {
  value: DateValue;
  long?: boolean;
  dateFormat?: string;
}
export const FormatDate = ({ value, long, dateFormat }: Props): JSX.Element => {
  const formatter = useFormatDate(dateFormat);
  return <>{formatter(value, long)}</>;
};

FormatDate.defaultProps = {
  long: true,
};
